// User-settings bindings (GET/PUT /user-settings). Mirrors iOS
// UserSettingsEndpoints / backend app/schemas/user_settings.py. We only surface
// the partial-grading toggles on the web; the blocking fields are iOS-only and
// passed through untouched.
import { api } from "./client";

export interface UserSettingsResponse {
  blocking_mode: string;
  blocking_enabled: boolean;
  activity_selection_b64: string | null;
  restriction_prefs: Record<string, unknown> | null;
  // Optional so a pre-0043 server response still types.
  live_grading_enabled?: boolean;
  live_correcting_enabled?: boolean;
  // Optional so a pre-0051 server response still types.
  translate_answers_enabled?: boolean;
  updated_at: string | null;
}

export interface UserSettingsUpdate {
  live_grading_enabled?: boolean;
  live_correcting_enabled?: boolean;
  translate_answers_enabled?: boolean;
}

export function getUserSettings(): Promise<UserSettingsResponse> {
  return api.get<UserSettingsResponse>("/user-settings");
}

export function putUserSettings(patch: UserSettingsUpdate): Promise<UserSettingsResponse> {
  return api.put<UserSettingsResponse>("/user-settings", patch);
}
